import { useMemo } from 'react';

import InputField from '../Forms/Input/InputField';
import FormModal from '../Modals/FormModal';

import { useCashWithdrawal } from '../../hooks/cash/useCashWithdrawal';
import { useCashSession } from '../../hooks/cash/useCashSession';

import QuickAmountButtons from '../Buttons/QuickAmountButtons';
import CashSessionInfoCard from '../CashStatus/CashSessionInfoCard';
import CashWithdrawalPreview from '../CashStatus/CashWithdrawalPreview';
import ModalActionButtons from '../Modals/Buttons/ModalActionButtons';

const quickAmounts = [10, 20, 50, 100, 200, 500];

const CashWithdrawalModal = () => {
  const { form, showModal, updateField, withdraw, close } = useCashWithdrawal();

  const { activeSession } = useCashSession();

  const amount = useMemo(() => {
    return parseFloat(String(form.amount));
  }, [form.amount]);

  const isInvalidAmount =
    isNaN(amount) ||
    amount <= 0 ||
    (activeSession && amount > activeSession.currentBalance);

  const handleSubmit = async () => {
    if (!activeSession) return;

    if (isInvalidAmount) {
      alert('Ingrese un monto válido');
      return;
    }

    await withdraw({
      ...form,
      amount,
      sessionId: activeSession.id,
    });
  };

  return (
    <FormModal
      isOpen={showModal}
      onClose={close}
      title="Registrar retiro de efectivo"
      maxWidth="max-w-5xl"
      overlayBg="black"
      zIndex="front"
    >
      <div className="space-y-6">
        {/* GRID PRINCIPAL */}
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.2fr_1fr]">
          {/* FORMULARIO */}
          <div className="space-y-4">
            <InputField
              label="Monto del retiro"
              name="amount"
              type="number"
              step="0.01"
              min={0}
              iconKey="dollar"
              value={form.amount}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('amount', e.target.value)
              }
            />

            {/* SELECCIÓN RÁPIDA */}
            <QuickAmountButtons
              amounts={quickAmounts}
              selected={Math.abs(Number(form.amount))}
              onSelect={(value) => updateField('amount', value.toFixed(2))}
            />

            <InputField
              label="Descripción"
              name="description"
              iconKey="document"
              type="text"
              placeholder="Motivo del retiro"
              value={form.description}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                updateField('description', e.target.value)
              }
            />
          </div>

          {/* CONTEXTO */}
          <div className="space-y-4">
            {activeSession && <CashSessionInfoCard />}

            {activeSession && (
              <CashWithdrawalPreview
                currentBalance={activeSession.currentBalance}
                amount={amount || 0}
              />
            )}
          </div>
        </div>

        {/* ACCIONES */}
        <ModalActionButtons
          onCancel={close}
          onConfirm={handleSubmit}
          confirmLabel="Registrar retiro"
          confirmColor="danger"
          disabled={isInvalidAmount}
        />
      </div>
    </FormModal>
  );
};

export default CashWithdrawalModal;
